import { AfterViewInit, Component, computed, effect, inject, input, OnInit, signal, ViewChild } from '@angular/core';
import { HistoryService } from '../../../services/history.service';
import { HistoryItem } from '../../../models/history-item';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { HistoryAttributeKey } from '../../../models/enums';
import { HistoryDescriptionPipe } from '../../../pipes/history-description.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortModule } from '@angular/material/sort';

@Component({
  selector: 'app-history-panel',
  imports: [
    MatProgressSpinnerModule,
    MatTableModule,
    HistoryDescriptionPipe,
    MatExpansionModule,
    MatBadgeModule,
    MatIconModule,
    MatSortModule,
  ],
  templateUrl: './history-panel.component.html',
  styleUrl: './history-panel.component.scss',
})
export class HistoryPanelComponent implements OnInit, AfterViewInit {
  entityType = input.required<string>();
  entityId = input.required<number>();
  readonly historyService = inject(HistoryService);
  loading = signal<boolean>(false);
  history = signal<HistoryItem[]>([]);
  displayedColumns = ['updatedOn', 'updatedBy', 'change', 'imported'];
  dataSource = new MatTableDataSource<HistoryItem>();

  @ViewChild(MatSort) sort!: MatSort;

  constructor() {
    effect(() => {
      this.dataSource.data = this.history();
    })
  }

  ngOnInit(): void {
    this.loading.set(true);
    this.historyService.getEntityHistory(this.entityType(), this.entityId()).subscribe({
      next: (v) => {
        // console.debug(v);
        this.loading.set(false);
        this.history.set(v);
      },
      error: (e) => {
        this.loading.set(false);
        console.error(e)
      }
    })

  }

  ngAfterViewInit() {
    // this.sort.sortChange.subscribe(ev => console.log('SORT FIRED', ev));
    this.dataSource.sort = this.sort;
    // this.dataSource.sortingDataAccessor = (item, property) => {
    //   switch (property) {
    //     case 'when':
    //       return new Date(item.updatedOn).getTime(); // numeric timestamp
    //     case 'who':
    //       return item.updatedBy?.toLowerCase?.() ?? '';
    //     default:
    //       return '';

    //   }
    // }
  }
}
